import OrderItemInterface from '../constants/interfaces/order-item-interface';
import { OrderItemType } from '../constants/types/order-item';
import CartItem from './cart-item';

export default class OrderItem implements OrderItemInterface {
  order: OrderItemType;
  constructor(props: OrderItemType) {
    this.order = props;
  }

  // Gift certificate voucher code (single value)
  get giftCertificateVoucherCode() {
    return this.order.giftCertificateVoucherCode || '';
  }

  // Gift certificate voucher id (single value)
  get giftCertificateVoucherId() {
    return this.order.giftCertificateVoucherId || '';
  }

  get date() {
    return this.order.date;
  }

  get orderId() {
    return this.order.order;
  }

  get totalPrice() {
    return this.order.totals.grandTotalPrice;
  }

  get totalPriceAsNumber() {
    return this.order.totals.grandTotalPriceAsNumber;
  }

  get shippingCost() {
    return this.order.totals.shippingPrice;
  }

  get totalDiscount() {
    return this.order.discounts.discount;
  }

  get items() {
    return this.order.items.map((item) => new CartItem({ cartItem: item }));
  }

  get hasDiscount() {
    return this.order.discounts.anyDiscount;
  }

  get shippingMethod() {
    return this.order.shippingMethod;
  }

  get statusDescription() {
    return this.order.statusDescription;
  }

  get address() {
    return this.order.address;
  }

  get currency() {
    return this.order.currency;
  }

  get shippingPriceAsNumber() {
    return this.order.totals.shippingPriceAsNumber;
  }

  get taxAddedAsNumber() {
    return this.order.totals.grandTotalPriceTaxAsNumber;
  }

  get taxPercent() {
    return this.order.totals.taxPercent;
  }

  get voucher() {
    return this.order.discounts.vouchers.length > 0
      ? this.order.discounts.vouchers[0].voucher
      : '';
  }

  get additionalNotes() {
    return this.order.additionalNotes || '';
  }

  get shippingAddress() {
    return this.order.shippingAddress;
  }

  get paymentMethod() {
    return this.order.paymentMethod;
  }

  get carrierService() {
    return this.order.carrierService;
  }

  get carrierAgent() {
    return this.order.carrierAgent;
  }

  get totals() {
    return this.order.totals;
  }

  get shipments() {
    return this.order.shipments;
  }

  get returns() {
    return this.order.returns || [];
  }

  get shippingMethodName() {
    return this.order.shippingMethodName;
  }

  get paymentMethodName() {
    return this.order.paymentMethodName;
  }

  get discounts() {
    return this.order.discounts;
  }

  get _rawOrderApiData() {
    return this.order._rawOrderApiData;
  }

  get groupName() {
    return this.order.groupName;
  }

  get sellerInfo() {
    return this.order.sellerInfo;
  }

  get sellerId() {
    return this.order.sellerId;
  }
}
